// extracted by mini-css-extract-plugin
export var avatar = "avatar-module--avatar--wE7uB";
export var container = "avatar-module--container--rykNB";
export var content = "avatar-module--content--ByDTj";
export var subtitle = "avatar-module--subtitle--Z2cBc";
export var title = "avatar-module--title--za7a1";